import { render } from "./case-contact.vue?vue&type=template&id=6322cf74&scoped=true&ts=true"
import script from "./case-contact.vue?vue&type=script&lang=ts"
export * from "./case-contact.vue?vue&type=script&lang=ts"

import "./case-contact.vue?vue&type=style&index=0&id=6322cf74&lang=scss&scoped=true"

import exportComponent from "C:\\Build\\vsts-agent-win-x64-3.218.0\\_work\\1\\s\\Connect\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6322cf74"]])

export default __exports__